import { Location } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [ButtonModule, RouterOutlet, TooltipModule],
})
export class MainLayoutComponent {
  isMobile = false;

  private location = inject(Location);
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() {
    this.checkMobileView();
  }

  onBackClick(): void {
    this.location.back();
  }

  onHomeClick(): void {
    this.router.navigate(['/', 'main', 'companies']);
  }

  onLogout(): void {
    this.authService.removeTokens();
    this.router.navigate(['/', 'auth', 'login']);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkMobileView();
  }

  private checkMobileView() {
    this.isMobile = window.innerWidth <= 768;
  }
}
